import * as React from 'react'
//import { Grid, Col, Row } from 'react-bootstrap';
import {Route} from 'react-router'
// import { Dashboard } from './Dashboard/Dashboard';
import ViolationsHistory from "./ViolationsHistory/ViolationsHistory";
import  SelectCamera  from './SelectCamera/SelectCamera';
import { NoMatch } from './NoMatch';


export const PrivateRoutes = (props: any) =>{
    if(window.localStorage["isLogged"]==="true"){
        return (
            <div>
                {/* <Route exact path="/dashboard" component={ Dashboard }/> */}
                <Route exact path="/selectcamera" component={ SelectCamera }/>
                <Route exact path="/eventsHistory" component={ ViolationsHistory }/>

            </div>
    )
    }
        
    else 
        return  <Route component={NoMatch} />

   
}
   


// WEBPACK FOOTER //
// ./src/Routes/PrivateRoutes.tsx